import { Button } from "@shopify/polaris";
import { zendeskSupportLogo } from "../../assets/images";
import { shopStore } from "@/stores";
import { useEffect, useState } from "react";
import { useSnapshot } from "valtio";

const ZendeskSupportWidget = () => {
    const shopStoreSnap = useSnapshot(shopStore);
    const [shouldShowZendeskBtn, setShouldShowZendeskBtn] = useState(false);

    useEffect(() => {
        if (
            shopStoreSnap.csStoreCreated &&
            shopStoreSnap.subscriptionActive &&
            shopStore.getZendeskWidgetKey()
        ) {
            setShouldShowZendeskBtn(true);
        } else {
            console.warn('Zendesk widget is not enabled');
        }
    }, [
        shopStoreSnap.csStoreCreated,
        shopStoreSnap.subscriptionActive,
        shopStoreSnap.config,
        shopStoreSnap.shopifyDomain,
    ]);

    return (
        <>
            {shouldShowZendeskBtn ? (
                <div
                    style={{
                        position: 'fixed',
                        bottom: '1rem',
                        right: '1rem',
                        cursor: 'pointer',
                    }}
                >
                    <Button
                        variant="tertiary"
                        icon={
                            <img
                                src={zendeskSupportLogo}
                                alt="Support logo"
                                style={{ height: '36px', objectFit: 'cover' }}
                            />
                        }
                        onClick={shopStore.openZendeskWidget}
                        accessibilityLabel="Support Button"
                    />
                </div>
            ) : null}
        </>
    );
};

export default ZendeskSupportWidget;